// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type InventoryItemId = ID<"inventoryItem">;
export const inventoryItemIdFormat = idFormat<InventoryItemId>({
  prefix: "ii_",
});
